import { Marker } from 'react-map-gl/mapbox';
import userIcon from '../../assets/user-marker.png'; // Ajusta la ruta según tu estructura

const UserMarker = ({ latitude, longitude }) => {
  if (!latitude || !longitude) return null;

  return (
    <Marker latitude={latitude} longitude={longitude} anchor="center">
      <img
        src={userIcon}
        alt="Usuario"
        style={{
          width: 30,
          height: 37,
          borderRadius: '50%',
          boxShadow: '0 0 4px rgba(0,0,0,0.3)'
        }}
      />
    </Marker>
  );
};

export default UserMarker;
